import React from 'react'
import { ArrowShortDownIcon } from '@fourthwall/icons'
import { Icon } from '../../Icon'
import type { TableHeadCellProps } from './types'
import * as Styled from './styled'

export const TableHeadCell = ({
  $sortable,
  direction,
  $compact,
  $alignment = 'left',
  $forOption,
  width = 1,
  $minWidth,
  onClick,
  children,
}: TableHeadCellProps) => {
  const renderIcon = () => {
    if (!$sortable) return null

    return (
      <Styled.IconContainer direction={direction}>
        <Icon component={ArrowShortDownIcon} height={10} />
      </Styled.IconContainer>
    )
  }

  return (
    <Styled.Container
      role="columnheader"
      $compact={$compact}
      $alignment={$alignment}
      $forOption={$forOption}
      $width={width}
      $minWidth={$minWidth}
      onClick={onClick}
      data-testid="TableHeadCell"
    >
      {children}
      {renderIcon()}
    </Styled.Container>
  )
}
